export const wrapValidator = (validator, typeName, typeChecker = null) => {
  return Object.assign(validator.bind(null), {
    typeName,
    typeChecker,
    isRequired: Object.assign(validator.isRequired.bind(null), {
      typeName,
      typeChecker,
      typeRequired: true
    })
  });
};